import { IFollowUpDonorForList } from '@nkr/models/index';
import { AdminGridWrapper } from '../../styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';
import { DonorAction } from '../donor-action';

interface IProps {
    centerId: number,
    list: IFollowUpDonorForList[],
    isLoading: boolean,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onItemSelected: (id: number, action: DonorAction) => void
}

const AdminSurveyList = (props: IProps) => {
    return (
        <AdminGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                centerId={props.centerId}
                isAdmin={true}
                isAdminLogin={true}
                isLoading={props.isLoading}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
                onItemSelected={props.onItemSelected}
            />
        </AdminGridWrapper>
    );
}

export default AdminSurveyList;